import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useSmoothScroll } from "@/components/landing/useSmoothScroll";
import { Footer } from "@/components/landing/Footer";
import Landing from "@/pages/Landing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Support from "@/pages/Support";

const Shell = () => {
  useSmoothScroll();
  return (
    <div className="grain min-h-screen bg-[#0A0B0E]" data-testid="landing-page">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
